let preloadPromise: ReturnType<typeof loadWorkbenchModel> | null = null;

export function loadWorkbenchModel() {
  return Promise.all([
    import("@/pages/StrategyCenterThreeD"),
    import("@/pages/Manifold"),
    import("@/components/manifold/ManifoldView"),
    import("@/components/manifold/ManifoldPlot"),
    import("@/components/manifold/ManifoldPostprocessing"),
  ]).then(([module]) => ({
    default: module.StrategyCenterThreeD,
  }));
}

export function preloadWorkbenchModel() {
  preloadPromise ??= loadWorkbenchModel();
  return preloadPromise;
}
